"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTotalOverageMillisecondsForCompany = void 0;
const calculate_usage_diff_in_milliseconds_for_company_1 = require("./calculate-usage-diff-in-milliseconds-for-company");
function calculateTotalOverageMillisecondsForCompany(company) {
    return (0, calculate_usage_diff_in_milliseconds_for_company_1.calculateUsageDiffInMillisecondsForCompany)(company, 'OVERAGE');
}
exports.calculateTotalOverageMillisecondsForCompany = calculateTotalOverageMillisecondsForCompany;
